import React from 'react';
import '../styles/cpanel.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "cPanel CPNL1",
    discount: "UP TO 92% OFF 1st month.",
    price: "$0.99",
    subtitle: "Perfect for personal websites, small businesses and developer web hosting.",
    features: [
      "25 Websites",
      "1 cPanel Account",
      "AlmaLinux 9",
      "NVMe SSD",
      "MariaDB",
      "Softaculous Apps Installer",
      "Social Media Management",
      "WordPress Management",
      "SiteJet Website Builder",
      "Free Daily Backups",
      "24/7 Tech Support",
      "Unlimited Free SSL",
      "Standard WordPress Acceleration",
      "Unlimited Bandwidth",
      "1-click WordPress Installation",
      "Standard DDoS Protection",
      "Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
    ],
  },
  {
    name: "cPanel CPNL5",
    discount: "UP TO 75% OFF 1st month.",
    price: "$4.49",
    subtitle: "High-performance shared hosting for larger blogs, agencies, and growing businesses.",
    features: [
      "50 Websites",
      "5 cPanel Accounts",
      "AlmaLinux 9",
      "NVMe SSD",
      "MariaDB",
      "Softaculous Apps Installer",
      "Social Media Management",
      "WordPress Management",
      "SiteJet Website Builder",
      "Free Daily Backups",
      "24/7 Tech Support",
      "Unlimited Free SSL",
      "Standard WordPress Acceleration",
      "Unlimited Bandwidth",
      "1-click WordPress Installation",
      "Standard DDoS Protection",
      "Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
    ],
  },
  {
    name: "Reseller WHM15",
    discount: "UP TO 50% OFF 1st month.",
    price: "$14.49",
    subtitle: "WHM Reseller — 15 cPanel accounts powered by Rocky Linux 9.5 and cPanel 128.",
    features: [
      "Dedicated IP",
      "15 cPanel Accounts",
      "cPanel + WHM | AlmaLinux 9",
      "Softaculous Apps Installer",
      "NVMe SSD",
      "MariaDB",
      "SSH Access",
      "WordPress Management",
      "Free Daily Backups",
      "24/7 Tech Support",
      "Unlimited Free SSL",
      "Advanced WordPress Acceleration",
      "Unlimited Bandwidth",
      "1-click WordPress Installation",
      "Enhanced DDoS Protection",
      "Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
    ],
  },
  {
    name: "Reseller WHM30",
    discount: "UP TO 56% OFF 1st month.",
    price: "$24.98",
    subtitle: "WHM Reseller — 30 cPanel accounts with full management capabilities for larger resellers.",
    features: [
      "Dedicated IP",
      "30 cPanel Accounts",
      "cPanel + WHM 128 | AlmaLinux 9",
      "Softaculous Apps Installer",
      "NVMe SSD",
      "MariaDB",
      "SSH Access",
      "WordPress Management",
      "Free Daily Backups",
      "24/7 Tech Support",
      "Unlimited Free SSL",
      "Advanced WordPress Acceleration",
      "Unlimited Bandwidth",
      "1-click WordPress Installation",
      "Enhanced DDoS Protection",
      "Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
    ],
  },
];

function Cpanel() {
  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/1st mo</span></span>
            </p>
            <a href="https://account.i-word.net/order/config/preconfig/cpanel" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Cpanel;
